export default [
  {
    path: '/credentials',
    name: 'public.credentialCourses',
    components: {
      default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/catalogue/index.vue'),
      header: () => import(/* webpackChunkName: "credential" */ '@/views/public/header/index.vue'),
      footer: () => import(/* webpackChunkName: "credential" */ '@/views/public/footer/index.vue')
    }
  },
  // {
  //   path: '/credential/dmhc/ccpa',
  //   name: 'credential.dmhc.ccpa',
  //   props: {
  //     default: true
  //   },
  //   meta: {
  //     affiliate: {
  //       id: 1,
  //       logo: 'https://d9hv9sikl36u8.cloudfront.net/images/ccpa/ccpa-logo.png',
  //       name: 'CCPA'
  //     }
  //   },
  //   components: {
  //     default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/dmhc/affiliate.vue')
  //   }
  // },
  // {
  //   path: '/credential/dmhc/cce',
  //   name: 'credential.dmhc.cce',
  //   props: {
  //     default: true
  //   },
  //   meta: {
  //     affiliate: {
  //       id: 2,
  //       logo: 'https://d9hv9sikl36u8.cloudfront.net/images/affiliates/cce.jpg',
  //       name: 'CCPA'
  //     }
  //   },
  //   components: {
  //     default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/dmhc/affiliate.vue')
  //   }
  // },
  // {
  //   path: '/credential/dmhc/vca',
  //   name: 'credential.dmhc.vca',
  //   props: {
  //     default: true
  //   },
  //   meta: {
  //     affiliate: {
  //       id: 3,
  //       logo: 'https://d9hv9sikl36u8.cloudfront.net/images/affiliates/vca.png',
  //       logoStyle: 'max-width:86px',
  //       name: 'VCA'
  //     },
  //   },
  //   components: {
  //     default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/dmhc/affiliate.vue')
  //   }
  // },
  {
    path: '/credential/:courseCode/:access',
    name: 'credential.course',
    props: {
      default: true
    },
    components: {
      default: () => import(/* webpackChunkName: "credential" */ `@/modules/credentialCourse/views/index.vue`)
    }
  },
  {
    // Bounces a new credential learner into the course on the learner portal
    // (AUS parity). Enrol.vue sends every purchase here.
    path: '/credential-courses/:slug/enrol-completed',
    name: 'credential.course.enrolCompleted',
    components: {
      default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/EnrolCompleted.vue')
    }
  },
  {
    path: '/credential/:courseCode/:access/thank-you',
    name: 'credential.course.thankyou',
    props: {
      default: true
    },
    components: {
      default: () => import(/* webpackChunkName: "credential" */ '@/modules/credentialCourse/views/Success.vue')
    }
  }
]
